export default "<h2 mat-dialog-title>{{data.title}}</h2>\n<mat-dialog-content>\n    {{getMessage()}}\n</mat-dialog-content>"